import React from 'react';

const Table = () => {
  return (
    <section className="table">
      <div className="container">
          <h5 className="text-center yellow-heading">Competitive Landscape</h5>
          <h3 className="text-center">Now You Can Show And Tell</h3>
          <p className="pre-table-text text-center">
            With LinkedIn and Indeed, you’re only a resume. ClipHire’s video
            platform empowers you to showcase all of you.
          </p>
        </div>
        <div className="container right-no-padding-mob">
          <div className=" table-wrapper position-relative ">
            <span className="big-gradient-circle" />
            <span className="big-gradient-circle small-gradient green-gradient" />
            <span className="big-gradient-circle red-gradient" />
            <div className="feature-table flex-row ">
              <div className="feature-list">
                <div className="feature-head">
                  <h4>Features</h4>
                </div>
                <div className="feature-block">
                  <h5>Digital Resume</h5>
                </div>
                <div className="feature-block">
                  <h5>Video Introduction</h5>
                </div>
                <div className="feature-block">
                  <h5>Verified References</h5>
                </div>
                <div className="feature-block">
                  <h5>Calendar Integration</h5>
                </div>
                <div className="feature-block">
                  <h5>Candidacy Toggle</h5>
                </div>
                <div className="feature-block">
                  <h5>In-App Messaging</h5>
                </div>
                <div className="feature-block">
                  <h5>Verified References</h5>
                </div>
                <div className="feature-block">
                  <h5>Resume Snapshot Link</h5>
                </div>
                <div className="feature-block">
                  <h5>Job Searching</h5>
                </div>
                <div className="feature-block">
                  <h5>Dynamic Job Search</h5>
                </div>
                <div className="feature-block">
                  <h5>Filter Job Results</h5>
                </div>
                <div className="feature-block">
                  <h5>One-Click Apply</h5>
                </div>
                <div className="feature-block">
                  <h5>Save Interesting Jobs</h5>
                </div>
                <div className="feature-block">
                  <h5>Automatic Email Alerts</h5>
                </div>
              </div>
              <div className="feature-body flex-row">
                <div className="single-feature">
                  <div className="feature-head">
                    <img
                      src="/img/cliphire-logo.svg"
                      alt=""
                      className="cliphire-logo-table"
                    />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                </div>
                <div className="single-feature">
                  <div className="feature-head">
                    <img
                      src="/img/linkedin-logo.svg"
                      alt=""
                      className="linkedin-logo-table"
                    />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                </div>
                <div className="single-feature">
                  <div className="feature-head">
                    <img
                      src="/img/indeed-logo.svg"
                      alt=""
                      className="indeed-logo-table"
                    />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check cross" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check " />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                  <div className="feature-block">
                    <span className="check" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
};

export default Table;
